// extracted by mini-css-extract-plugin
module.exports = {"side-menu-wrapper":"SideMenu_side-menu-wrapper__23zx_","side-menu":"SideMenu_side-menu__15cOo","selected":"SideMenu_selected__2n9c9"};